import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { highlight, HighlightOptions, MatchType } from '@app/utils/highlight';

@Pipe({
  name: 'highlightText',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  /**
   * Highlight the given term inside the given content.
   *
   * @param content String that is search for the term, can be either plain text or html
   * @param term String to search for
   * @param typeOrOptions Default: { caseSensitive: false, type: 'Multi' }
   */
  transform(
    content: string = null,
    term: string = null,
    typeOrOptions?: MatchType | Partial<HighlightOptions>
  ): SafeHtml {
    if (typeof typeOrOptions === 'string') {
      typeOrOptions = {
        type: typeOrOptions,
      };
    }

    return highlight(content, term, typeOrOptions);
  }
}
